<div
  [class.with-ai-rail]="aiBuilder.railMounted()"
  [class.ai-rail-outside-project]="aiBuilder.outsideProject()"
  [class.ai-rail-entering]="aiBuilder.railEntering()"
  [class.ai-rail-leaving]="aiBuilder.railLeaving()"
  [style.--ai-rail-animation.ms]="railAnimationMs"
  [attr.data-ai-rail]="aiBuilder.railMounted() ? 'mounted' : 'unmounted'"
  class="app-root-container"
  data-testId="app-root-container"
>
  <!-- AI-assisted builder. On Make it docks as a conversation rail left of the designer, under
       its bar; on Plan it takes the frame below the bar, the designer still mounted underneath. -->
  @defer (when aiBuilder.railMounted()) {
    @if (aiBuilder.railMounted()) {
      <flx-ai-builder-rail class="ai-builder-frame rail midnight" />
    }
  }

  @defer (when aiBuilder.planOpen()) {
    @if (aiBuilder.planOpen()) {
      <flx-ai-builder-plan-view class="ai-builder-frame full midnight" />
    }
  }

  <div class="main-content-wrapper">
    <div
      [ngClass]="
        zenModeActivated
          ? 'zen-mode transition duration-200 ease-in'
          : ' transition duration-500 ease-out'
      "
      (click)="routerOutletWrapperClick()"
      class="flex flex-row w-full h-full min-h-0"
      tabindex="0"
    >
      @if (zenModeActivated && planEnabled) {
        <flx-ai-agent-plan
          [ngClass]="
            zenModeActivated
              ? 'transition delay-150 duration-300 ease-in-out'
              : 'transition duration-300 ease-out'
          "
          class="flex flex-col max-w-1/4 w-1/4 h-full text-white border-neutral-600 border border-r border-t-0 border-b-0 border-l-0 p-0 pt-4 hidden [@media(min-width:1800px)]:w-1/5 [@media(min-width:1800px)]:max-w-1/5 [@media(min-width:1799px)]:flex"
        >
        </flx-ai-agent-plan>

        <p-drawer
          (onClose)="hidePlanSidebar()"
          [(visible)]="planSidebarVisible"
          styleClass="w-[600px] sidebar-bg m-0 p-0"
        >
          <ng-template pTemplate="header">
            <div
              class="flex flex-col w-full text-white text-[20px] font-bold p-4 border-neutral-600 border-0"
            >
              Execution Plan
            </div>
          </ng-template>
          <flx-ai-agent-plan
            [showTitle]="false"
            [ngClass]="
              zenModeActivated
                ? 'transition delay-150 duration-300 ease-in-out'
                : 'transition duration-300 ease-out'
            "
            class="flex flex-col w-full h-full text-white p-0 border-neutral-600 border-0"
          >
          </flx-ai-agent-plan>
        </p-drawer>
      }
      <div
        [ngClass]="
          zenModeActivated
            ? 'transition duration-300 ease-in-out max-w-1/2w-1/2 [@media(min-width:1800px)]:w-3/5 [@media(min-width:1800px)]:max-w-3/5'
            : 'transition duration-300 ease-out'
        "
        class="flex flex-col flex-auto h-full min-h-0 min-w-0"
      >
        @if (zenModeActivated) {
          <flx-ai-agent-header
            [ngClass]="
              zenModeActivated
                ? 'transition delay-150 duration-300 ease-in-out'
                : 'transition duration-300 ease-out'
            "
          ></flx-ai-agent-header>
        }

        <div class="wrapper-pip h-full w-full min-h-0 glow-element">
          <div
            [ngClass]="
              zenModeActivated
                ? 'keep-background pip-page ' +
                  (showPendingMessage() ? 'glow' : '') +
                  ' transition duration-300 w-full ease-in-out drop-shadow-[0_10px_15px_rgba(255,255,255,0.25)] [@media(min-height:1023px)]:max-h-full'
                : 'transition duration-300 ease-out'
            "
            [class.h-full]="!zenModeActivated"
            [class.h-fit]="zenModeActivated"
            id="overlay-root"
            class="flex flex-col w-full min-h-0"
          >
            <router-outlet></router-outlet>
          </div>
        </div>
        @if (zenModeActivated) {
          <div
            [ngClass]="
              zenModeActivated
                ? 'transition delay-150 duration-300 ease-in-out'
                : 'transition duration-300 ease-out'
            "
            class="flex-row w-full h-auto border-1 text-white border-neutral-600 border border-r-0 border-t-1 border-b-0 border-l-0 pt-2 [@media(min-height:1023px)]:flex"
          >
            <flx-ai-agent-footer class="flex flex-col w-full h-auto"></flx-ai-agent-footer>
          </div>
        }
      </div>
      @if (zenModeActivated) {
        <div
          [ngClass]="
            zenModeActivated
              ? 'transition delay-150 duration-300 ease-in-out '
              : 'transition duration-300 ease-out'
          "
          class="flex flex-col h-full text-white max-w-1/4 w-1/4 border-neutral-600 border-0 border-l p-0 min-w-[400px] hidden [@media(min-width:1800px)]:w-1/5 [@media(min-width:1800px)]:max-w-1/5 [@media(min-width:1599px)]:flex"
        >
          <div class="flex flex-row w-full p-6 border-b border-neutral-600">
            <div
              class="flex flex-row w-full h-full justify-between items-center text-[20px] font-bold"
            >
              <div class="flex flex-row w-full h-full justify-start items-center">
                Chat with Agent
              </div>
              <div class="flex flex-row w-auto h-full justify-end items-center gap-3 pt-1">
                <i
                  (click)="onAutonomyLevelChange({ value: 0 })"
                  class="ph ph-user text-yellow-400 hover:text-yellow-500 hover:cursor-pointer hover:bg-black/40 rounded-lg p-1"
                  pTooltip="Human-as-Driver Level"
                  tooltipPosition="left"
                  tabindex="0"
                ></i>
                <p-slider
                  [ngModel]="autonomyLevel"
                  [min]="0"
                  [max]="2"
                  [step]="1"
                  [pTooltip]="'Autonomy Level: ' + autonomyLevel"
                  (onChange)="onAutonomyLevelChange($event)"
                  class="autonomy-level"
                  styleClass="w-14"
                  tooltipPosition="bottom"
                />
                <i
                  (click)="onAutonomyLevelChange({ value: 2 })"
                  class="ph ph-sparkle text-yellow-400 hover:text-yellow-500 hover:cursor-pointer hover:bg-black/40 rounded-lg p-1"
                  pTooltip="Agent-as-Driver Level"
                  tooltipPosition="left"
                  tabindex="0"
                ></i>
              </div>
            </div>
          </div>
          <flx-side-chat-window
            [sidePanelMode]="false"
            class="flex w-full h-full"
          ></flx-side-chat-window>
        </div>
        <p-drawer
          (onClose)="hideChatSidebar()"
          [(visible)]="chatSidebarVisible"
          styleClass="w-[600px] sidebar-bg m-0 p-0"
          position="right"
        >
          <ng-template pTemplate="header">
            <div
              class="flex flex-row w-full text-white text-[20px] font-bold border-neutral-600 border-0 p-6 border-l h-[60px] items-center justify-center"
            >
              <div class="flex flex-row w-full h-full justify-start items-center">
                Chat with Agent
              </div>
              <div
                [pTooltip]="'Autonomy Level: ' + autonomyLevel"
                class="flex flex-row w-auto h-full justify-end items-center gap-3 pt-1"
                tooltipPosition="bottom"
              >
                <i
                  (click)="onAutonomyLevelChange({ value: 0 })"
                  class="ph ph-user text-yellow-400"
                  pTooltip="Human-as-Driver Level"
                  tooltipPosition="left"
                  tabindex="0"
                ></i>
                <p-slider
                  [ngModel]="autonomyLevel"
                  [min]="0"
                  [max]="2"
                  [step]="1"
                  (onChange)="onAutonomyLevelChange($event)"
                  class="autonomy-level"
                  styleClass="w-14"
                />
                <i
                  (click)="onAutonomyLevelChange({ value: 2 })"
                  class="ph ph-sparkle text-yellow-400"
                  pTooltip="Agent-as-Driver Level"
                  tooltipPosition="left"
                  tabindex="0"
                ></i>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="content">
            <flx-side-chat-window
              [sidePanelMode]="true"
              [ngClass]="
                zenModeActivated
                  ? 'transition delay-150 duration-300 ease-in-out'
                  : 'transition duration-300 ease-out'
              "
              class="flex flex-col w-full h-full text-white p-0 border-neutral-600 border-0 border-t border-l border-r-0 border-b-0"
              style="max-height: calc(100vh - 60px)"
            >
            </flx-side-chat-window>
          </ng-template>
          <ng-template pTemplate="footer">
            <div class="flex flex-row w-full h-full justify-end items-center p-0 m-0"></div>
          </ng-template>
        </p-drawer>
        <p-drawer
          (onClose)="hideDocumentsSidebar()"
          [(visible)]="documentsSidebarVisible"
          styleClass="max-w-1/4 w-1/4 min-w-[400px] lg:w-1/4 lg:max-w-1/4 sidebar-bg m-0 p-0"
          position="right"
          blockScroll="true"
        >
          <ng-template pTemplate="header">
            <div
              class="flex flex-col w-full text-white text-[20px] font-bold border-neutral-600 border-0 p-4 border-l"
            >
              Documents
            </div>
          </ng-template>
          <ng-template pTemplate="content">
            <flx-ai-agent-documents
              class="flex w-full h-full border-neutral-600 border-0 border-t border-l border-r-0 border-b-0"
            ></flx-ai-agent-documents>
          </ng-template>
          <ng-template pTemplate="footer">
            <div class="flex flex-row w-full h-full justify-end items-center p-0 m-0"></div>
          </ng-template>
        </p-drawer>
        <p-drawer
          (onClose)="hideArchivedSidebar()"
          [(visible)]="archivedSidebarVisible"
          styleClass="max-w-1/5 w-1/5 min-w-[400px] lg:w-1/5 lg:max-w-1/5 sidebar-bg m-0 p-0"
          position="left"
          blockScroll="true"
        >
          <ng-template pTemplate="header">
            <div
              class="flex flex-col w-full text-white text-[20px] font-bold border-neutral-600 border-0 p-4 border-l"
            >
              Previous Plans
            </div>
          </ng-template>
          <ng-template pTemplate="content">
            <flx-ai-generated-plans
              class="flex w-full h-full border-neutral-600 border-0 border-t border-l border-r-0 border-b-0"
            ></flx-ai-generated-plans>
          </ng-template>
          <ng-template pTemplate="footer">
            <div class="flex flex-row w-full h-full justify-end items-center p-0 m-0"></div>
          </ng-template>
        </p-drawer>
      }
    </div>
  </div>
</div>

@if (!zenModeActivated) {
  <flx-ai-fab />
}
